import { PRICE_DIRECTION, PRICE_TYPE } from "../constants/pricingConstants"

// Currency goes before the amount (+$10); percentage stays after (+10%).
export const formatRateChange = ({ direction, priceValue, priceType }) => {
  const sign = direction === PRICE_DIRECTION.INCREASE ? "+" : "-"
  if (priceType === PRICE_TYPE.PERCENT) return `${sign}${priceValue}%`
  return `${sign}$${priceValue}`
}
